import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button, CircularProgress, Alert } from '@mui/material';
import { Context } from '../index';
import OilFillingService from '../services/OilFillingService';

export default function OilFilling() {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchNext = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await OilFillingService.getNext();
            if (res?.status === 204 || !res?.data?.order) {
                setLoading(false);
                return;
            }
            const orderId = res.data.order.id;
            navigate(`/oil-filling/${orderId}`, { replace: true });
        } catch (err) {
            setError(err?.response?.data?.error || err?.message || 'Не удалось получить заказ');
            setLoading(false);
        }
    }, [navigate]);

    useEffect(() => {
        fetchNext();
    }, [fetchNext]);

    const handleLogout = async () => {
        try { await store.logout(); } catch (_) {}
        navigate('/login', { replace: true });
    };

    if (loading) {
        return (
            <Container maxWidth="sm">
                <Box display="flex" flexDirection="column" alignItems="center" gap={2} py={8}>
                    <CircularProgress />
                    <Typography>Ищем следующий заказ...</Typography>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box display="flex" flexDirection="column" alignItems="center" gap={3} py={8}>
                {error && (
                    <Alert severity="error" sx={{ width: '100%' }}>
                        {error}
                    </Alert>
                )}

                {!error && (
                    <Typography variant="h5" align="center">
                        Подходящих заказов на данный момент нет
                    </Typography>
                )}

                <Button variant="contained" color="primary" onClick={fetchNext}>
                    Проверить ещё раз
                </Button>

                <Button variant="outlined" color="inherit" onClick={handleLogout}>
                    Выйти
                </Button>
            </Box>
        </Container>
    );
}
